// Zambian phone numbers. The database stores one canonical form, +260 followed by
// nine digits, and enforces it with a check constraint and a unique index. That
// unique index is the church's main defence against the same person being
// entered twice by departments that cannot see each other, so every way a
// treasurer might type a number must land on the SAME canonical value.

/** Canonical +260XXXXXXXXX, or null if the input is not a plausible Zambian number. */
export function normalizeZambianPhone(input: string): string | null {
  // Keep digits and a leading plus; drop spaces, dashes, brackets, dots.
  const cleaned = input.trim().replace(/[\s\-().]/g, '')
  if (cleaned === '') return null
  if (!/^\+?\d+$/.test(cleaned)) return null

  let national: string
  if (cleaned.startsWith('+260')) national = cleaned.slice(4)
  else if (cleaned.startsWith('00260')) national = cleaned.slice(5)
  else if (cleaned.startsWith('260') && cleaned.length === 12) national = cleaned.slice(3)
  else if (cleaned.startsWith('0')) national = cleaned.slice(1)
  else if (cleaned.length === 9) national = cleaned
  else return null

  // Nine digits, and Zambian mobile/landline numbers never start with 0 or 1 after the prefix.
  if (!/^[2-9]\d{8}$/.test(national)) return null
  return '+260' + national
}

/** Friendly display: +260 97 123 4567 */
export function formatZambianPhone(canonical: string | null | undefined): string {
  if (!canonical) return ''
  const m = /^\+260(\d{2})(\d{3})(\d{4})$/.exec(canonical)
  return m ? `+260 ${m[1]} ${m[2]} ${m[3]}` : canonical
}
